import React from 'react';
import { ErrorBoundary } from '../../../../components/shared/ErrorBoundary';
import ContactPanel from '../ContactPanel';
import { ChatConversation } from '../../hooks/useChat';

interface ChatDetailsProps {
    conversation: ChatConversation;
    connectionId?: string;
    onClose: () => void;
}

/**
 * Fallback de erro para o painel de detalhes
 */
const DetailsFallback: React.FC = () => (
    <div className="flex h-full w-full items-center justify-center bg-card text-error">
        Erro ao carregar painel
    </div>
);

export const ChatDetails: React.FC<ChatDetailsProps> = ({ conversation, connectionId, onClose }) => {
    return (
        <ErrorBoundary fallback={<DetailsFallback />}>
            <ContactPanel conversation={conversation} connectionId={connectionId} onClose={onClose} />
        </ErrorBoundary>
    );
};

export default ChatDetails;
